import CallStatistics from '../components/statistics/CallStatistics';
export default function CallStatisticsPage() { return <CallStatistics />; }
